import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "age-options-inputs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OptionsInput = _resolveComponent("OptionsInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.formattedAges.filter((item) => item.value.startsWith('woman')).length)
      ? (_openBlock(), _createBlock(_component_OptionsInput, {
          key: 0,
          modelValue: _ctx.selectedOptions,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOptions) = $event)),
          items: _ctx.formattedAges.filter((item) => item.value.startsWith('woman'))
        }, null, 8, ["modelValue", "items"]))
      : _createCommentVNode("", true),
    _hoisted_2,
    (_ctx.formattedAges.filter((item) => item.value.startsWith('man')).length)
      ? (_openBlock(), _createBlock(_component_OptionsInput, {
          key: 1,
          modelValue: _ctx.selectedOptions,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedOptions) = $event)),
          items: _ctx.formattedAges.filter((item)=> item.value.startsWith('man'))
        }, null, 8, ["modelValue", "items"]))
      : _createCommentVNode("", true)
  ]))
}